(() => {
  if (window.AceiiMobileProductSummary) return;
  window.AceiiMobileProductSummary = true;

  const rootSelector = "[data-aceii-mobile-product-layout]";
  const mobileQuery = window.matchMedia("(max-width: 767.98px)");
  const targetSelectors = [
    ".hdt-product__title[data-type='title']",
    "[id*='trustwill_trustoo_star_rating_widget']",
    ".hdt-product__price",
    "[data-aceii-installment-options]",
  ];

  const states = new WeakMap();

  const createState = (root) => {
    const summary = root.querySelector("[data-aceii-mobile-product-summary]");
    const info = root.querySelector(".hdt-product__info-container");

    if (!summary || !info) return null;

    const anchors = targetSelectors.map((selector) => {
      const node = info.querySelector(selector);
      if (!node) return { selector, anchor: null };

      const anchor = document.createComment(`aceii-mobile-summary:${selector}`);
      node.before(anchor);
      return { selector, anchor };
    });

    const state = { summary, info, anchors };
    states.set(root, state);
    return state;
  };

  const getState = (root) => states.get(root) || createState(root);

  const moveToMobileSummary = (root, state) => {
    state.anchors.forEach(({ selector }) => {
      const node = root.querySelector(selector);
      if (node && node.parentElement !== state.summary) {
        state.summary.append(node);
      }
    });

    state.summary.hidden = state.summary.children.length === 0;
    root.classList.toggle("aceii-mobile-summary-ready", !state.summary.hidden);
  };

  const restoreDesktopOrder = (root, state) => {
    state.anchors.forEach(({ selector, anchor }) => {
      if (!anchor?.parentNode) return;

      const node = state.summary.querySelector(selector);
      if (node) anchor.after(node);
    });

    state.summary.hidden = true;
    root.classList.remove("aceii-mobile-summary-ready");
  };

  const sync = (root) => {
    if (!(root instanceof Element)) return;

    const state = getState(root);
    if (!state) return;

    if (mobileQuery.matches) {
      moveToMobileSummary(root, state);
    } else {
      restoreDesktopOrder(root, state);
    }
  };

  const scan = (scope = document) => {
    if (scope instanceof Element && scope.matches(rootSelector)) sync(scope);
    scope.querySelectorAll?.(rootSelector).forEach(sync);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scan(), { once: true });
  } else {
    scan();
  }

  mobileQuery.addEventListener("change", () => scan());
  document.addEventListener("shopify:section:load", (event) => scan(event.target));
  document.addEventListener("variant-change", (event) => {
    const root = event.target.closest?.(rootSelector);
    if (root) requestAnimationFrame(() => sync(root));
  });
})();
